import { axios } from "./HttpClient";

export const AdminService = {
  newStudent: (values) => {
    return axios.post("/students", values);
  },
  login: (values) => {
    return axios.post("/staff/login", values);
  },
  getStudents: () => {
    return axios.get("/students");
  },
  getExcel: () => {
    return axios.get("students/excel", { responseType: "blob" });
  },
  deleteStudent: (id) => {
    return axios.delete("/students/" + id);
  },
  sendEmailToGuardians: (values) => {
    return axios.post("/students/email", values);
  },
  sendSurvey: (values) => {
    return axios.post("/survey", values);
  },
  getSurveys: () => {
    return axios.get("/survey");
  },
};
